module.exports = __webpack_public_path__ + "img/snow-leopard-icon.77ec1d02.png";